import { Button, DropdownItem, Icon } from 'semantic-ui-react'
import { format } from 'date-fns'
import * as React from 'react'

import { Collection, Recipe, RecipeSchedule } from '../../types'
import RemoteValue from '../remoteValues/remoteValue'

interface Props {
  onUpdateScheduleClick(schedule: RecipeSchedule): void
  onDeleteScheduleClick(schedule: RecipeSchedule): void
  relatedCollection: Collection
  schedule: RecipeSchedule
}

export default function CardMenuItemRecipe(props: Props) {
  const { onUpdateScheduleClick, onDeleteScheduleClick, schedule } = props

  return (
    <DropdownItem
      className="group relative !flex cursor-pointer items-baseline gap-3 !whitespace-normal py-2 pl-4 pr-12 hover:bg-slate-50"
      onClick={() => onUpdateScheduleClick(schedule)}
    >
      <RemoteValue
        predicate={(r: Recipe) => (
          <>
            <div>
              <Icon
                name="lab"
                fitted
                className="scale-150 [&.icon]:![box-shadow:none]"
                size="small"
                color="grey"
                circular
              />
            </div>
            <div>
              <div className="text-lg leading-snug">
                {r.name}{' '}
                <span className="ml-1 rounded-md border border-blue-700 px-1.5 py-0.5 text-[9px] font-semibold uppercase text-blue-700">
                  automatic
                </span>
              </div>
              <div className="mt-0.5 text-sm text-slate-500">
                Will run on {format(schedule.whenToRun || 0, 'PPp')}
              </div>
            </div>
          </>
        )}
        collection="recipes"
        id={schedule.recipeId}
      />
      <div className="absolute right-2 top-1.5 opacity-0 group-hover:opacity-100">
        <Button
          onClick={(e) => {
            e.stopPropagation()
            onDeleteScheduleClick(schedule)
          }}
          className="!mr-0"
          icon="trash alternate outline"
          compact
          basic
          size="mini"
        />
      </div>
    </DropdownItem>
  )
}
